import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../../layout/AppLayout";
import { Arrow } from "../../../components/svg/Wallet/Wallet";
import { Card } from "../../../components/Card";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "sonner";

const BankDetails = {
  bankName: "Micro Finance Bank",
  accountNumber: "545677122233",
  name: "John Doe",
};
const TransferInfo = [
  "Copy the account number above.",
  "Open your preferred bank app.",
  "Paste and fund your account.",
  "Payment reflects almost immediately if successful.",
];

export const BankTransfer = () => {
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="min-h-screen px-4 pt-16">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate(-1)}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer "
          />
          <p className="font-bold text-xl text-primary-black">Bank Transfer</p>
        </div>
        <div className="mt-12">
          <Card className="mb-5">
            <h3 className="text-base font-semibold text-primary-black ">
              Your Account Details
            </h3>
            <div className="bg-[#F8F8F8] rounded-full p-2.5 flex items-center justify-between gap-2.5 my-5">
              <p className="text-base font-semibold text-primary-black ">
                {BankDetails.accountNumber}
              </p>
              <CopyToClipboard
                text={BankDetails.accountNumber}
                onCopy={() => {
                  toast.success("Copied");
                }}
              >
                <button className="text-white bg-[#2741D6] px-6 py-3 rounded-full text-xs font-semibold">
                  Copy Account
                </button>
              </CopyToClipboard>
            </div>
            <div>
              <div className="flex items-center gap-2.5 mb-2.5">
                <Bank className="w-6 h-6" />
                <p className="font-semibold text-primary-black text-sm">
                  {BankDetails.bankName}
                </p>
              </div>
              <div className="flex items-center gap-2.5">
                <UserIcon />
                <p className="font-semibold text-primary-black text-sm">
                  {BankDetails.name}
                </p>
              </div>
            </div>
          </Card>
          <Card>
            <h3 className="text-base font-semibold text-primary-black mb-4 ">
              How to Make a Transfer
            </h3>
            <ul className="ml-3">
              {TransferInfo.map((x, i) => {
                return (
                  <li
                    key={i}
                    className="text-sm font-light text-primary-black pt-1.5  relative pl-4 before:content-['•'] before:absolute before:left-0 before:text-primary-black before:text-xs"
                  >
                    {x}
                  </li>
                );
              })}
            </ul>
            <p className="text-primary-black text-sm pt-1.5">
              <span className="text-xs text-[#2741D6] font-bold">Note:</span>{" "}
              Minimum deposit is{" "}
              <span className="text-xs text-[#2741D6] font-bold">₦500 </span>
            </p>
          </Card>
        </div>
      </div>
    </AppLayout>
  );
};

const Bank = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2.5" fill="#ECEFFF" />
      <path
        d="M9.24902 11.0002H8.24902V14.5002H9.24902V11.0002ZM12.249 11.0002H11.249V14.5002H12.249V11.0002ZM16.499 15.5002H6.99902V16.5002H16.499V15.5002ZM15.249 11.0002H14.249V14.5002H15.249V11.0002ZM11.749 7.63024L14.354 9.00024H9.14402L11.749 7.63024ZM11.749 6.50024L6.99902 9.00024V10.0002H16.499V9.00024L11.749 6.50024Z"
        fill="#2741D6"
      />
    </svg>
  );
};

const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2.5" fill="#ECEFFF" />
      <path
        d="M8.00195 15C8.00195 14.4695 8.21267 13.9608 8.58774 13.5857C8.96281 13.2107 9.47152 13 10.002 13H14.002C14.5324 13 15.0411 13.2107 15.4162 13.5857C15.7912 13.9608 16.002 14.4695 16.002 15C16.002 15.2652 15.8966 15.5195 15.7091 15.7071C15.5215 15.8946 15.2672 16 15.002 16H9.00195C8.73674 16 8.48238 15.8946 8.29485 15.7071C8.10731 15.5195 8.00195 15.2652 8.00195 15Z"
        stroke="#2741D6"
        strokeLinejoin="round"
      />
      <path
        d="M11.999 11.0003C12.8275 11.0003 13.499 10.3287 13.499 9.50027C13.499 8.67185 12.8275 8.00027 11.999 8.00027C11.1706 8.00027 10.499 8.67185 10.499 9.50027C10.499 10.3287 11.1706 11.0003 11.999 11.0003Z"
        stroke="#2741D6"
      />
    </svg>
  );
};
